/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Monitoring } from '../models/Monitoring';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MonitoringsService {
    /**
     * Gets the monitoring by its id.
     * @param id The monitoring id.
     * @returns Monitoring Success
     * @throws ApiError
     */
    public static getMonitoring(
        id: string,
    ): CancelablePromise<Monitoring> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/Monitorings/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * Deletes the monitoring by its id.
     * @param id The monitoring id.
     * @returns any Success
     * @throws ApiError
     */
    public static deleteMonitoring(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/Monitorings/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }
    /**
     * Gets all monitorings.
     * @param executionFrequency To filter specific execution settings.
     * @returns Monitoring Success
     * @throws ApiError
     */
    public static getMonitorings(
        executionFrequency?: string,
    ): CancelablePromise<Array<Monitoring>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/Monitorings',
            query: {
                'executionFrequency': executionFrequency,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                422: `Client Error`,
            },
        });
    }
    /**
     * Gets the monitorings of the default account of the currently logged in user.
     * @returns Monitoring Success
     * @throws ApiError
     */
    public static getMonitoringsCurrentUserDefaultAccount(): CancelablePromise<Array<Monitoring>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/user/account/Monitorings',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Creates or updates the provided monitoring for the default account and the currently logged in user.
     * @param requestBody The new or updated monitoring.
     * @returns Monitoring Success
     * @throws ApiError
     */
    public static upsertMonitoringCurrentUserDefaultAccount(
        requestBody?: Monitoring,
    ): CancelablePromise<Monitoring> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/user/account/Monitorings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                422: `Client Error`,
            },
        });
    }
}
